module.exports = __webpack_public_path__ + "static/rmh-logo-907c37af7f8cacc2f74ce602222693eb.svg";